import React from 'react';
import styled from 'styled-components';
import { colors } from '../constants';
import Text from './styled/Text';
import { MdClose } from 'react-icons/md';

const StyledTagWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const StyledTag = styled.div`
  display: flex;
  padding: 4px 8px;
  border-radius: 4px;
  min-width: 60px;
  background-color: ${colors.grey95};
  align-items: center;
  justify-content: center;
  height: 32px;
  margin-right: 8px;

  svg {
    width: 21px;
    height: 21px;
    margin-left: 4px;
  }
`;

export function TagFormatter({ data, field, onDeleteTag, editable }) {
  const handleDeleteItem = value => e => {
    e.stopPropagation();
    if (editable) {
      const changed = data.data[field].filter(item => {
        if (item === value) return false;
        return true;
      });
      onDeleteTag({ ...data.data, [field]: changed }, true);
    }
  };

  return (
    <>
      <StyledTagWrapper>
        {data.data[field]?.map(item => (
          <StyledTag key={item}>
            <Text variant="body-small">{item}</Text>
            {onDeleteTag && (
              <MdClose
                fill={colors.grey80}
                onClick={handleDeleteItem(item)}></MdClose>
            )}
          </StyledTag>
        ))}
      </StyledTagWrapper>
    </>
  );
}
